import { render, staticRenderFns } from "./AllocateChannels.vue?vue&type=template&id=700472f5&scoped=true&"
import script from "./AllocateChannels.vue?vue&type=script&lang=js&"
export * from "./AllocateChannels.vue?vue&type=script&lang=js&"
import style0 from "./AllocateChannels.vue?vue&type=style&index=0&id=700472f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700472f5",
  null
  
)

export default component.exports